module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__dealer-followup--section"
  }, [(_vm.alreadySent) ? _c('div', {
    staticClass: "system-builder__dealer-followup--container"
  }, [_c('p', [_vm._v("Sorry, this request has been closed.")]), _vm._v(" "), _c('p', [_vm._v("Please submit another request if you would like to receive a quote from another dealer.")]), _vm._v(" "), _c('a', {
    staticClass: "button__solid--blue",
    on: {
      "click": _vm.goToViewSystem
    }
  }, [_vm._v("Request Another Quote")])]) : _c('div', {
    staticClass: "system-builder__dealer-followup--container"
  }, [_c('h1', [_vm._v("Follow-Up Reminder Sent")]), _vm._v(" "), _c('p', [_vm._v("We apologize that you have not been contacted yet by this dealer. A follow-up e-mail, regarding your E-Quote, has been sent to this dealer.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c24a5212","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/DealerFollowup.vue
// module id = 434
// module chunks = 1